export default __webpack_public_path__ + "static/media/comingSoonZh.06d209df.png";